import { render, staticRenderFns } from "./BookADemo.vue?vue&type=template&id=dd00ce76&"
import script from "./BookADemo.vue?vue&type=script&lang=js&"
export * from "./BookADemo.vue?vue&type=script&lang=js&"
import style0 from "./BookADemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports